import { render, staticRenderFns } from "./LogoManagerForm.vue?vue&type=template&id=4a5c8019&"
import script from "./LogoManagerForm.vue?vue&type=script&lang=ts&"
export * from "./LogoManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports